export default __webpack_public_path__ + "static/media/supportChat.5e04c702.svg";